import { render } from "./DefaultBackend.vue?vue&type=template&id=4c93e5ba"
import script from "./DefaultBackend.vue?vue&type=script&lang=js"
export * from "./DefaultBackend.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__